<template>
	<div class="hd-mod-frame-vitamin-exit js-mod-frame-vitamin-exit">
		<div class="hd-mod-frame-vitamin-exit__bg tween-virus-exit"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-1"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-2"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-3"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-4"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-5"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-6"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-7"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-8"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-9"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-10"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-11"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-12"></div>
		<div class="hd-mod-frame-vitamin-exit__block tween-virus-exit-block tween-virus-exit-block-13"></div>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-frame-vitamin-exit {
		@include absolute-lr-0();
		@include box(100%);

		&__bg {
			@include absolute-lr-0();
			@include box(100%);
			background: url('../../assets/images/mod-virus-exit.png');
			@include background-cover();
			background-position: center;
			@include animation-float-mini();
			@include fade-out();
		}

		.tween-virus-exit-block {
			@include absolute-lr-0();
			@include box(100%);
			// @include animation-float-mini();
			@include fade-out();
			transform: translate(30px, -30px);

			&-1 {
				background: url('../../assets/images/mod-virus-exit-1.png');
				@include background-cover();
			}
			&-2 {
				background: url('../../assets/images/mod-virus-exit-2.png');
				@include background-cover();
			}
			&-3 {
				background: url('../../assets/images/mod-virus-exit-3.png');
				@include background-cover();
			}
			&-4 {
				background: url('../../assets/images/mod-virus-exit-4.png');
				@include background-cover();
			}
			&-5 {
				background: url('../../assets/images/mod-virus-exit-5.png');
				@include background-cover();
			}
			&-6 {
				background: url('../../assets/images/mod-virus-exit-6.png');
				@include background-cover();
			}
			&-7 {
				background: url('../../assets/images/mod-virus-exit-7.png');
				@include background-cover();
			}
			&-8 {
				background: url('../../assets/images/mod-virus-exit-8.png');
				@include background-cover();
			}
			&-9 {
				background: url('../../assets/images/mod-virus-exit-9.png');
				@include background-cover();
			}
			&-10 {
				background: url('../../assets/images/mod-virus-exit-10.png');
				@include background-cover();
			}
			&-11 {
				background: url('../../assets/images/mod-virus-exit-11.png');
				@include background-cover();
			}
			&-12 {
				background: url('../../assets/images/mod-virus-exit-12.png');
				@include background-cover();
			}
			&-13 {
				background: url('../../assets/images/mod-virus-exit-13.png');
				@include background-cover();
			}
		}

		// Animation 
		&[data-state="animation-ready"] {
			.tween-virus-exit {
				@include transition-frame-fade-in();
			}

			.tween-virus-exit-block {
				@include transition-frame-fade-in();

				&.tween-virus-exit-block-1 { transition-delay: 0.25s;}
				&.tween-virus-exit-block-2 { transition-delay: 0.5s; }
				&.tween-virus-exit-block-3 { transition-delay: 0.75s; }
				&.tween-virus-exit-block-4 { transition-delay: 1s; }
				&.tween-virus-exit-block-5 { transition-delay: 1.25s; }
				&.tween-virus-exit-block-6 { transition-delay: 1.5s; }
				&.tween-virus-exit-block-7 { transition-delay: 1.75s; }
				&.tween-virus-exit-block-8 { transition-delay: 2s; }
				&.tween-virus-exit-block-9 { transition-delay: 2.25s; }
				&.tween-virus-exit-block-10 { transition-delay: 2.5s; }
				&.tween-virus-exit-block-11 { transition-delay: 2.75s; }
				&.tween-virus-exit-block-12 { transition-delay: 3s; }
				&.tween-virus-exit-block-13 { transition-delay: 3.25s; }
			}
		}
	}
</style>

